import NegativeKeywordConstants from "../constants/NegativeKeywords";
import { INegativeKeywordCollState, NegativeKeywordCollCampaignActionTypes } from "../interfaces/NegativeKeywordColl";
import { RESET_CLIENT_STATE } from "../constants/ClientConstants";

const initialState: INegativeKeywordCollState = {
    entities: {},
    loadedAt: null,
    error: null
};

function negativeKeywordCollCampaignReducer(
    state = initialState,
    action: NegativeKeywordCollCampaignActionTypes
): INegativeKeywordCollState {
    switch (action.type) {
        case NegativeKeywordConstants.REQUEST_NEGATIVE_KEYWORD_COLL_CAMPAIGNS:
            return { ...state, loadedAt: null, entities: {}, error: null };
        case NegativeKeywordConstants.REQUEST_NEGATIVE_KEYWORD_COLL_CAMPAIGNS_FAIL:
            return { ...state, loadedAt: null, error: action.payload };
        case NegativeKeywordConstants.REQUEST_NEGATIVE_KEYWORD_COLL_CAMPAIGNS_SUCCESS:
            return { ...state, loadedAt: new Date(), entities: action.payload, error: null };
        case RESET_CLIENT_STATE:
            return initialState;
        default:
            return state;
    }
}

export default negativeKeywordCollCampaignReducer;
